import React from 'react';
import BaseSection from './_shared/BaseSection';
import WhoWeAreCard from '../cards/WhoWeAreCard';

const WhoWeAreSection = ({ id }, ref) => {
    return (
        <BaseSection
            id={id}
            name="Our Goal"
            introduction="Score unique moments anytime, anywhere."
            iSize="section-text-big"
            iColor="mylads-text-gradient"
            styles="xl:w-3/4 1xl:w-10/12"
            ref={ref}
        >
            <WhoWeAreCard />
        </BaseSection>
    );
};

export default React.forwardRef(WhoWeAreSection);
